import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsCustomBreadcrumbComponent } from './cms-custom-breadcrumb.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomBreadcrumbModule } from '../../../../misc/breadcrumb/breadcrumb.module';

@NgModule({
  declarations: [CmsCustomBreadcrumbComponent],
  imports: [CommonModule, CustomBreadcrumbModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CustomCMSBreadcrumb: {
          component: CmsCustomBreadcrumbComponent,
        },
      },
    }),
  ],
})
export class CmsCustomBreadcrumbModule {}
